import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withData } from "../common/WithData";
import StudentController from "../api/StudentController";
import { Container, Row, Col } from "react-bootstrap";
import StudentSupportView from "../components/StudentSupportView";
import ErrorBoundary from "./ErrorBoundry";

class StudentSupport extends React.Component
{
    studentController: StudentController;

    constructor(props: any) 
    {
        super(props);

        this.studentController = new StudentController();
    }

    render(): React.ReactNode
    {
        const StudentSupportData = withData(
            StudentSupportView,
            "Student Support",
            async () => await this.studentController.getStudentSupportRecords()
        );

        return <Fragment>
            <ErrorBoundary>
                <StudentSupportData />
            </ErrorBoundary>
        </Fragment>;
    }

}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent
});

export default connect(mapStateToProps)(StudentSupport);